import React from 'react';
import { Text } from '@front10/base-elements';
import { useTranslation } from '@front10/utils';

export function Disclaimer({
  componentName = 'premium-experience-grid'
}: {
  componentName: string;
}) {
  const translate = useTranslation();
  return (
    <Text variant="fontSize7">
      {translate(`cmp-${componentName}-footer-disclaimer`, 'Powered by EveryMundo')}
    </Text>
  );
}
